import React from 'react';
import classNames from 'classnames';
import { Popover, PopoverContent, PopoverChevron, PopoverAnchor } from '@fiverr-private/popover';
import { getContext } from '@fiverr-private/fiverr_context';
import { grey_1100 } from '@fiverr-private/sass/helpers/index';
import { TooltipProps } from './types';
import classes from './index.module.scss';

const Tooltip = ({
  position = 'top',
  size = 'md',
  appendToBody = false,
  isOpen,
  onOpenChanged,
  content,
  disableFlip = false,
  children,
  as = 'span',
}: TooltipProps) => {
  const { isTouch } = getContext();

  return (
    <Popover
      triggerEvent={isTouch ? 'click' : 'hover'}
      isOpen={isOpen}
      position={position}
      onOpenChanged={onOpenChanged}
      disableFlip={disableFlip}
    >
      <PopoverAnchor as={as}>{children}</PopoverAnchor>
      {content && (
        <PopoverContent
          backgroundColor={grey_1100}
          appendToBody={appendToBody}
          zIndex="tooltip"
          disablePadding
          disableBoxShadow
          borderRadius="sm"
        >
          <PopoverChevron size={size} />
          <div
            role="tooltip"
            className={classNames(classes.tooltip, {
              [classes.sizeSm]: size === 'sm',
            })}
          >
            {content}
          </div>
        </PopoverContent>
      )}
    </Popover>
  );
};

export default Tooltip;
